import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import HtmlRedirect from "./components/HtmlRedirect";
import Home from "./pages/Home";
import About from "./pages/About";
import Books from "./pages/Books";
import Press from "./pages/Press";
import Contact from "./pages/Contact";
import ThankYou from "./pages/ThankYou";
import FindingClaritySample from "./pages/FindingClaritySample";
import MurderAtTheMailboxSample from "./pages/MurderAtTheMailboxSample";
import TheBuilding from "./pages/TheBuilding";
import { Toaster } from "./components/ui/sonner";

const CHROMELESS_PATHS = ["/the-building", "/building"];

function AppLayout() {
  const { pathname } = useLocation();
  const bare = CHROMELESS_PATHS.includes(pathname);
  return (
    <>
      <HtmlRedirect />
      <ScrollToTop />
      {!bare && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/books" element={<Books />} />
          <Route path="/books/finding-clarity-sample" element={<FindingClaritySample />} />
          <Route path="/books/murder-at-the-mailbox-sample" element={<MurderAtTheMailboxSample />} />
          <Route path="/news" element={<Press />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/the-building" element={<TheBuilding />} />
          <Route path="/building" element={<TheBuilding />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AppLayout />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
